import type { FC, ReactNode } from 'react';
import { Box } from '@mui/material';

import { theme } from '../../styles/theme';

interface MapContainerProps {
  $isVisible: boolean;
  children: ReactNode;
}

export const MapContainer: FC<MapContainerProps> = ({
  $isVisible,
  children,
}) => (
  <Box
    sx={{
      height: '100%',
      display: $isVisible ? 'block' : 'none',
      [`@media (min-width: ${theme.breakPoints.desktop}px)`]: {
        padding: theme.spacing(4),
        boxSizing: 'border-box',
      },
    }}
  >
    {children}
  </Box>
);
